Vue.component('cabinet-index', {
    props: {
        birthdayraw: ""
    },
    data() {
        return {
            birthday: '',
            address: {
                street: '',
                house: '',
                stage: '',
                floor: '',
                apartment: '',
            },
        };
    },
    methods: {
        deleteAddress(id) {
            axios.get('/cabinet/delete-address?id=' + id).then(function (response) {
                if (response.data.success) {
                    $('.js-address-' + id).detach();
                } else {
                    if (response.data.error) {
                        alert(response.data.error);
                    }
                }
            });
        },
        saveName(e) {
            let value = e.target.value;
            if (!value) {
                alert("Пожалуйста, введите имя");
            } else {
                axios.get('/cabinet/change-name?name=' + value).then(function (response) {
                    if (!response.data.success) {
                        if (response.data.error) {
                            alert(response.data.error);
                        }
                    }
                });
            }
        },
        saveDate(e) {
            let value = e.target.value;
            if (confirm("Ву уверены, что хотите поменять дату рождения на " + value + "? Дальнейшее изменение будет возможно только через службу поддержки")) {
                axios.get('/cabinet/change-birthday?birthday=' + value).then(function (response) {
                    if (!response.data.success) {
                        if (response.data.error) {
                            alert(response.data.error);
                        }
                    }
                });
            }
        },
        addAddress() {
            // JS is perfect
            let data = JSON.parse(JSON.stringify(this.address));
            CsrfHelper.addCsrf(data);

            let _this = this;
            axios.post('/cabinet/add-address', data).then(function (response) {
                if (response.data.success) {
                    window.location.href = window.location.href;
                } else {
                    if (response.data.error) {
                        alert(response.data.error);
                    }
                }

            });
        }
    },
    created() {
        this.birthday = this.birthdayraw;
    }
});